import { AuditDataDto } from 'services/api/api-client.types';
import styles from './DocumentNameTooltipTitle.module.scss';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import { format } from 'date-fns';
import clsx from 'clsx';

export const DocumentNameTooltipTitle = (props: {
  name: string;
  auditData: AuditDataDto | null;
}) => {
  return (
    <div className={styles.tooltipMessage}>
      <div
        className={clsx(
          styles.documentName,
          props.auditData ? styles.documentNamePadding : null,
        )}
      >
        {props.name}
      </div>
      {props.auditData && (
        <>
          {props.auditData.modified && (
            <ActivityItem
              action="modified"
              date={props.auditData.modified.date}
              byName={props.auditData.modified.byName}
            />
          )}

          {props.auditData.created && props.auditData.modified && (
            <div className={styles.tooltipSeparator}></div>
          )}

          {props.auditData.created && (
            <ActivityItem
              action="created"
              date={props.auditData.created.date}
              byName={props.auditData.created.byName}
            />
          )}
        </>
      )}
    </div>
  );
};

const ActivityItem = (props: {
  action: 'modified' | 'created';
  date: Date;
  byName: string;
}) => {
  const i18n = useScopedTranslation(
    'Page.Projects.ProjectDetailsPage.FoldersTree.TreeItem.documentTooltip',
  );

  return (
    <div className={styles.activityItem}>
      <div>
        {i18n.t(props.action, {
          date: format(props.date, 'dd.MM.yyyy, HH:mm'),
        })}
      </div>
      <div>{i18n.t('by', { userName: props.byName })}</div>
    </div>
  );
};
